import AddOfficerFormReducer from "./Users/AddOfficerFormReducer";
import AddUserFormReducer from "./Users/AddUserFormReducer";
import AuditsReducer from "./Audits/AuditsReducer";
import ActsReducer from "./Audits/ActsReducer";
import SitesReducer from "./Audits/SitesReducer";
import CreateAuditReducer from "./Audits/CreateAuditReducer";
import AuditReducer from "./Audits/AuditReducer";
import RemediationReducer from "./Remediation/RemediationReducer";
import AddRemediationPlanFormReducer from "./Remediation/AddRemediationPlanFormReducer";
import EditRemediationPlanFormReducer from "./Remediation/EditRemediationPlanFormReducer";
import AllSitesListReducer from "./Organizations/AllSitesListReducer";
import AllUsersListReducer from "./Users/AllUsersListReducer";
import AuthReducer from "./Auth/AuthReducer";
import EditUserFormReducer from "./Users/EditUserFormReducer";
import UserLoginFormReducer from "./Auth/UserLoginFormReducer";
import UserRegisterFormReducer from "./Auth/UserRegisterFormReducer";
import AffiliatesReducer from "./Affiliates/AffiliatesReducer";
import EditAffiliateFormReducer from "./Affiliates/EditAffiliateFormReducer";
import AddAffiliateFormReducer from "./Affiliates/AddAffiliateFormReducer";
import AffiliateAgreementsReducer from "./Affiliates/AffiliateAgreementsReducer";
import TasksReducer from "./Tasks/TasksReducer";
import TaskReducer from "./Tasks/TaskReducer";
import TasksForUserReducer from "./Tasks/TasksForUserReducer";
import CreateTaskReducer from "./Tasks/CreateTaskReducer";
import IncidentsReducer from "./Incidents/IncidentsReducer";
import IncidentNotesReducer from "./Incidents/IncidentNotesReducer";
import IncidentTypesReducer from "./Incidents/IncidentTypesReducer";
import IncidentManagerReducer from "./Incidents/IncidentManagerReducer";
import AddIncidentFormReducer from "./Incidents/AddIncidentFormReducer";
import ImportantDocumentsReducer from "./Dashboard/ImportantDocumentsReducer";
import ReportIncidentReducer from "./Dashboard/ReportIncidentReducer";
import TrainingReducer from "./Dashboard/TrainingReducer";
import AlertReducer from "./Alerts/AlertReducer";
import AlertsReducer from "./Alerts/AlertsReducer";
import OrgSiteDeptReducer from "./Organizations/OrgSiteDeptReducer";
import UsersReducer from "./Users/UsersReducer";
import UsersByOrgReducer from "./Users/UsersByOrgReducer";
import RolesReducer from "./Users/RolesReducer";
import RolesUserReducer from "./Users/RolesUserReducer";
import ReportsReducer from "./Reports/ReportsReducer";
import CreateReportReducer from "./Reports/CreateReportReducer";
import FoldersReducer from "./Documents/FoldersReducer";
import DepartmentsReducer from './Organizations/DepartmentsReducer';
import FolderContentsReducer from "./Documents/FolderContentsReducer";
import DocumentReducer from "./Documents/DocumentReducer"
import GapsReducer from "./Gaps/GapsReducer";
import StatsReducer from "./Dashboard/StatsReducer";
import UserStatsReducer from "./Dashboard/UserStatsReducer";
import StepsReducer from "./Dashboard/StepsReducer";
import UserOrgSiteReducer from "./Auth/UserOrgSiteReducer";
// import SetUserOrgSiteReducer from "./Auth/SetUserOrgSiteReducer";
import DevicesReducer from "./Devices/DevicesReducer";
import FilesReducer from "./Documents/FilesReducer";
import AttestationsReducer from "./Tasks/AttestationsReducer";
import UnapprovedFilesReducer from "./Documents/UnapprovedFilesReducer";
import AffiliatesAuditReducer from "./Affiliates/AffiliatesAuditReducer";
import SettingsReducer from "./Users/SettingsReducer";
import CreateOrgReducer from "./Organizations/CreateOrgReducer";
import SessionModalReducer from "./SessionModal/SessionModalReducer";

import CreateUsersBulkReducer from "./Users/CreateUsersBulkReducer";

import CreateEvidenceReducer from "./Evidence/CreateEvidenceReducer";
import EvidenceReducer from "./Evidence/EvidenceReducer";
import DatatableReducer from "./Datatable/DatatableReducer";

import DashboardTasksReducer from "./Dashboard/DashboardTasksReducer";

import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

export default history =>
    combineReducers({
        router: connectRouter(history),
        UserLoginFormReducer,
        UserRegisterFormReducer,
        AddUserFormReducer,
        AuditsReducer,
        ActsReducer,
        SitesReducer,
        CreateAuditReducer,
        AuditReducer,
        RemediationReducer,
        AddOfficerFormReducer,
        EditUserFormReducer,
        AuthReducer,
        AllUsersListReducer,
        AllSitesListReducer,
        AddRemediationPlanFormReducer,
        EditRemediationPlanFormReducer,
        AffiliatesReducer,
        EditAffiliateFormReducer,
        AddAffiliateFormReducer,
        AffiliateAgreementsReducer,
        TasksReducer,
        TaskReducer,
        CreateTaskReducer,
        IncidentNotesReducer,
        IncidentsReducer,
        IncidentTypesReducer,
        IncidentManagerReducer,
        AddIncidentFormReducer,
        ImportantDocumentsReducer,
        ReportIncidentReducer,
        TrainingReducer,
        AlertReducer,
        OrgSiteDeptReducer,
        AlertsReducer,
        UsersReducer,
        UsersByOrgReducer,
        RolesReducer,
        ReportsReducer,
        CreateReportReducer,
        FoldersReducer,
        DepartmentsReducer,
        FolderContentsReducer,
        DocumentReducer,
        GapsReducer,
        CreateUsersBulkReducer,
        RolesUserReducer,
        StatsReducer,
        StepsReducer,
        UserOrgSiteReducer,
        // SetUserOrgSiteReducer,
        DevicesReducer,
        FilesReducer,
        AttestationsReducer,
        TasksForUserReducer,
        UserStatsReducer,
        UnapprovedFilesReducer,
        AffiliatesAuditReducer,
        SettingsReducer,
        CreateOrgReducer,
        SessionModalReducer,
        CreateEvidenceReducer,
        EvidenceReducer,
        DatatableReducer,
        DashboardTasksReducer,
    });
